import { render, staticRenderFns } from "./PopupBanner.vue?vue&type=template&id=33968d6b&scoped=true"
import script from "./PopupBanner.vue?vue&type=script&lang=js"
export * from "./PopupBanner.vue?vue&type=script&lang=js"
import style0 from "./PopupBanner.vue?vue&type=style&index=0&id=33968d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33968d6b",
  null
  
)

export default component.exports